module.exports = __webpack_public_path__ + "img/turntable.c0781220.png";